<style scoped>
.telephone-wrap {
  position: fixed;
  top: calc(50% + 180px);
  right: 0;
  cursor: pointer;
  align-items: center;
  height: 70px;
  z-index: 99;
}
.tel-bottom {
  position: relative;
  height: 50px;
  width: 50px;
  border-radius: 25px;
  background-color: #1c96d4;
  margin-left: 5px;
}
.tel-image {
  height: 32px;
  width: 20px;
  margin: 8px 15px;
}
.text {
  color: #fff;
  font-size: 12px;
  text-align: center;
}
.work {
  /* padding-top: 15px; */
  width: 190px;
  height: 70px;
  line-height: 70px;
  background: url("../../../assets/image/common/common_work_time_bg@2x.png")
    center center no-repeat;
}
.work-text {
  float: right;
  margin-right: 20px;
  text-align: center;
  font-size: 16px;
}
.tel {
  color: #666666;
}
.time {
  color: #999999;
  margin-top: 22px;
}
.cover {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  border-radius: 25px;
  background-color: rgba(49, 49, 49, 0.23);
}
.tel-img {
  margin-left: 25px;
  margin-top: 27px;
}
</style>

<template>
  <div
    class="telephone-wrap flex-box"
    @mouseenter="telStatusChange"
    @mouseleave="telStatusChange"
  >
    <div v-if="isHover">
      <div class="work">
        <img :src="pic" class="tel-img" /><span class="work-text tel"
          >0571-56865686</span
        >
        <!-- <div class="work-text time">8：30-18：00</div> -->
      </div>
    </div>
    <div class="tel-bottom">
      <img :src="img" alt="" class="tel-image" />
      <!-- <div class="text">电话咨询</div> -->
      <div class="cover" v-if="isHover"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "telephone",
  data() {
    return {
      img: require("../../../assets/image/common/common_tel@2x.png"),
      pic: require("../../../assets/image/common/dh1.png"),
      isHover: false,
    };
  },
  methods: {
    telStatusChange() {
      this.isHover = !this.isHover;
    },
  },
};
</script>




// WEBPACK FOOTER //
// src/components/page/common/Telephone.vue